import { render, staticRenderFns } from "./SettingsItemView.vue?vue&type=template&id=2e0cc915&scoped=true&"
import script from "./SettingsItemView.vue?vue&type=script&lang=ts&"
export * from "./SettingsItemView.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsItemView.vue?vue&type=style&index=0&id=2e0cc915&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0cc915",
  null
  
)

export default component.exports